import { useCallback, useRef, useState } from "react";
import api from "./api";

// Voce di Fuma via OpenAI TTS gestito da Emergent. L'audio parte SOLO su gesto utente.
// Ritorna: speak(text) (play/pausa toggle sull'ultimo audio), stop, stato, muted, toggleMute.
export function useFumaVoice() {
  const audioRef = useRef(null);
  const lastTextRef = useRef("");
  const [state, setState] = useState("idle"); // idle | loading | playing | paused
  const [muted, setMuted] = useState(() => {
    try { return localStorage.getItem("fuma_voice_off") === "1"; } catch (e) { return false; }
  });

  const stop = useCallback(() => {
    const a = audioRef.current;
    if (a) { try { a.pause(); a.currentTime = 0; } catch (e) {} }
    setState("idle");
  }, []);

  const speak = useCallback(async (text) => {
    if (!text) return;
    const a = audioRef.current;
    const sameText = lastTextRef.current === text;
    // Toggle pausa/riproduzione sullo stesso audio
    if (a && sameText && state === "playing") { a.pause(); setState("paused"); return; }
    if (a && sameText && state === "paused") { try { await a.play(); setState("playing"); return; } catch (e) {} }
    // Nuova sintesi
    if (a) { try { a.pause(); } catch (e) {} }
    setState("loading");
    try {
      const { data } = await api.post("/tts/speak", { text });
      const audio = new Audio(`data:audio/mp3;base64,${data.audio}`);
      audioRef.current = audio;
      lastTextRef.current = text;
      audio.onended = () => setState("idle");
      audio.onerror = () => setState("idle");
      await audio.play();
      setState("playing");
    } catch (e) {
      setState("idle");
    }
  }, [state]);

  const toggleMute = useCallback(() => {
    setMuted((m) => {
      const v = !m;
      try { localStorage.setItem("fuma_voice_off", v ? "1" : "0"); } catch (e) {}
      if (v) stop();
      return v;
    });
  }, [stop]);

  return { speak, stop, state, playing: state === "playing", loading: state === "loading", muted, toggleMute };
}
